import React from "react"
import loader from "static/img/svg/Spinner-1s-200px.svg"
import css from "./Preloader.module.scss"

function Preloader() {
  return <img src={loader} alt="" className={css.loader} />
}

export default Preloader
